module.exports = __webpack_public_path__ + "img/bold.76ad9f56.svg";